import { SnackbarStatus } from '@weareopenr/component-library';
import { PublishType } from './types';
import { getPublishTypeLabel } from 'src/helpers/getPublishTypeLabel/getPublishTypeLabel';

const getSuccessMessage = (publishType: PublishType, scheduleTime: string | undefined, scheduleName?: string) => {
  if (scheduleTime && scheduleName) {
    return `Your product publication '${scheduleName}' has been successfully scheduled.`;
  }
  return `You have successfully ${scheduleTime ? 'scheduled ' : 'published '}${getPublishTypeLabel(publishType).description}.`;
};

export const successNotification = (
  publishType: PublishType,
  scheduleTime: string | undefined,
  scheduleName?: string,
) =>
  ({
    status: SnackbarStatus.SUCCESS,
    message: getSuccessMessage(publishType, scheduleTime, scheduleName),
  }) as const;

export const errorNotification = (publishType: PublishType, scheduleTime: string | undefined, error?: string) => {
  const action = scheduleTime ? 'scheduling' : 'publishing';
  const description = getPublishTypeLabel(publishType).description;
  const errorSuffix = error ? `: ${error}` : '';
  return {
    status: SnackbarStatus.ERROR,
    message: `Something went wrong whilst ${action} ${description}${errorSuffix}.`,
  } as const;
};
